import { List, Record } from "immutable";
import { defaultOpeningProps, IOpeningData, IOpeningRecord } from "common/records/Opening";
import { openingEstimationFromJSON } from "common/records/OpeningEstimation";

export const windowFromJSON = (json: Partial<IWindowData>): WindowRecord => {
  const recordData: IWindowRecord = { ...(json as any) };
  recordData.kind = "Window";

  if (json.opening_estimations) {
    recordData.opening_estimations = List(json.opening_estimations.map((oe) => openingEstimationFromJSON(oe)));
  }

  return new WindowRecord(recordData);
};

export type IWindowData = IOpeningData;

export type IWindowRecord = IOpeningRecord;

export class WindowRecord extends Record(defaultOpeningProps) implements IWindowRecord {}
